import React, { useState, useRef, useMemo, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { PriceEditAddForm } from "./PriceEditAddForm";
import { useSnackbar } from "notistack";

import { Link } from "react-router-dom";
import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { useSubheader } from "../../../_metronic/layout";
import { createShopifyPricing, fetchSingleShopify, updateShopifyPricing } from "../../../actions/shopify-pricing/shopify";


export function PriceEdit({
  history,
  match: {
    params: { id },
  },
}) {

  const { enqueueSnackbar } = useSnackbar();
  const initShopifyInfo = {
    plan_name: "",
    plan_type: "monthly",
    plan_desc: "",
    plan_price: "",
    inventory_type: "unlimited",
    plan_inventory: ""
  };

  const { shopifyForEdit } = useSelector(
    (state) => ({
      shopifyForEdit: id ? state.shopifyPricing?.shopifyForEdit : undefined,
    }),
    shallowEqual
  );

  // Subheader
  const suhbeader = useSubheader();

  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!id) {
      suhbeader.setBreadcrumbs([{ pathname: '/shopify-price', title: 'Price' }, { pathname: '', title: 'Add Price' }]);
    } else {
      suhbeader.setBreadcrumbs([{ pathname: '/shopify-price', title: 'Price' }, { pathname: '', title: 'Edit Price' }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useMemo(async () => {
    if (id === undefined) {
      return;
    }

    await dispatch(fetchSingleShopify(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dispatch]);

  // set Title
  useMemo(() => {
    let _title = id ? "" : "Add Pricing Plan";
    suhbeader.setTitle(_title);
    setTitle(_title);

    if (id) {
      _title = "Edit Pricing Plan";
      setTitle(_title);
      suhbeader.setTitle(_title);
    }
    return {
      _title,
    };
  }, [id, suhbeader]);

  const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  const saveShopifyInfo = (values) => {

    values.plan_name = titleCase(values.plan_name);
    setIsLoading(true);
    if (!id) {
      dispatch(createShopifyPricing(values)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/shopify-price`);

            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });
            setIsLoading(false);
          }
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });
          setIsLoading(false);
        }
      });
    } else {

      dispatch(updateShopifyPricing(values, id)).then(async (data) => {
        if (data.payload.status) {
          if (data && data.payload) {
            await history.push(`/shopify-price`);
            await enqueueSnackbar(data.payload.message, {
              variant: "success",
              autoHideDuration: 4500,
            });
            setIsLoading(false);
          }
        } else {
          await enqueueSnackbar(data.payload.message, {
            variant: "error",
            autoHideDuration: 4500,
          });

          setIsLoading(false);
        }
      });
    }
  };

  const btnRef = useRef();
  const saveShopifyButtonClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToList = () => {
    history.push(`/shopify-price`);
  };

  return (
    <Card>
      {false && <ModalProgressBar />}

      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveShopifyButtonClick}>
            {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
          <li className='nav-item' onClick={() => setTab("basic")}>
            <Link
              to={history.location.pathname}
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle='tab'
              role='tab'
              aria-selected={(tab === "basic").toString()}>
              Basic info
            </Link>
          </li>
        </ul>
        <div className='mt-5'>
          {tab === "basic" && (
            <PriceEditAddForm
              shopify={shopifyForEdit || initShopifyInfo}
              id={id}
              btnRef={btnRef}
              saveShopifyInfo={saveShopifyInfo}
            />
          )}
          {/* If you add new tab than add more */}
        </div>
      </CardBody>
      <hr />
      <CardHeader title=''>
        <CardHeaderToolbar>
          <button
            type='button'
            onClick={backToList}
            className='btn btn-light'>
            <i className='fa fa-arrow-left'></i>
            Back
          </button>
          {`  `}

          {`  `}
          <button
            type='submit'
            className='btn btn-primary ml-2'
            disabled={isLoading}
            onClick={saveShopifyButtonClick}>
            {isLoading ? "Saving..." : "Save"}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
    </Card>
  );
}
